import React from 'react';
import API from '../../../api';
import Card from './card';

export default class ListProfiles extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      list: this.props.content,
      selected: false
    }
    this.profileQuantity = this.profileQuantity.bind();
    this.handleClick = this.handleClick.bind();
    this.findProfileSelected = this.findProfileSelected.bind();
  }

  componentWillReceiveProps(next){
    // let list = next.content;
    // this.setState({list: list});
  }

  profileQuantity = (el, value) => {
    let list = this.props.content;
    list.map((category) => {
      category.profiles.map((item) => {
        if(item.name == el.props.content.name){
          item.quantity = value;
        }
      })
    })
    this.props.profiles(list);
  }

  findProfileSelected = (profile) => {
    return profile.selected === true;
  }

  handleClick = (e) => {
  }

  render() {
    let content = null;
    let data = [];
    let title = `Your Profiles`;
    
    const template = () => {
      return(
        <div>
          <h3>{ title }</h3>
          <div className="list-cards">
            { this.props.content.map( (data, index) => {
              let card = data;
              if(card.selected ){
                return card.profiles.map( (item, i) => {
                  if( item.selected){
                    return <Card 
                      key={`${card.name}-${card.min_range}-${i}`}
                      content={item} 
                      quantity={this.profileQuantity} 
                      min_range={card.min_range} 
                      max_range={card.max_range} />
                  }
                })
              }
            })}
          </div>
        </div>
      )    
    }

    let selected = [];
    this.props.content.map( category => {
      if(category.selected){
        selected = category.profiles.filter( e => e.selected === true)
        if(selected.length > 0){
          content = template();
          return;
        }
      }
    })
    
    return (
      <section className="card-profile">
        {content}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/build-your-team/views/descriptionProfiles.js